import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './computed-metric.reducer';

export const ComputedMetricDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const computedMetricEntity = useAppSelector(state => state.computedMetric.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="computedMetricDetailsHeading">
          <Translate contentKey="rainspotApp.computedMetric.detail.title">ComputedMetric</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{computedMetricEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="rainspotApp.computedMetric.name">Name</Translate>
            </span>
          </dt>
          <dd>{computedMetricEntity.name}</dd>
          <dt>
            <span id="formula">
              <Translate contentKey="rainspotApp.computedMetric.formula">Formula</Translate>
            </span>
          </dt>
          <dd>{computedMetricEntity.formula}</dd>
        </dl>
        <Button tag={Link} to="/computed-metric" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/computed-metric/${computedMetricEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ComputedMetricDetail;
